<template>
  <div class="emap-flow-select-m">
    <van-cell 
      :title="label" 
      :is-link="!disabled"
      :value="display" 
      :required="required"
      :value-class="valueClass" 
      @click="handleSelect"
      title-style="flex: 0 0 90px">
      <template #right-icon>
        <van-icon name="arrow" class="van-cell__right-icon" v-if="!loading && !disabled"/>
        <van-loading type="spinner" size="24px" v-if="loading && !disabled"/>
      </template>
    </van-cell>
    <van-popup v-model="popup" position="bottom">
      <div class="van-hairline--top-bottom van-picker__toolbar">
        <button type="button" class="van-picker__cancel" @click="handleCancel">取消</button>
        <button type="button" class="van-picker__confirm" @click="handleConfirm">确认</button>
      </div>
      <component
        :ref="type"
        :is="'atom-' + type"
        :options="options"
        :value-key="valueKey"
        :label-key="labelKey"
      ></component> 
    </van-popup>
  </div>
</template>

<script>
  import AtomPicker from './atom-picker'
  const isArray = (value) => Object.prototype.toString.call(value) === "[object Array]"

  export default {
    name: "AtomSelect",
    components: {
      AtomPicker
    },
    data() {
      return {
        display: '',
        popup: false,
        loading: false
      }
    },
    props: {
      value: [String, Array],
      label: String,
      required: Boolean,
      labelKey: {
        type: String,
        default: "label"
      },
      valueKey: {
        type: String,
        default: "value"
      },
      type: String,
      options: {
        type: Array,
        default() {
          return []
        }
      },
      multiple: Boolean,
      remote: Boolean,
      disabled: Boolean
    },
    watch: {
      value: function() {
        this.getInitialDisplay()
      },
      options: function() {
        this.getInitialDisplay()
      }
    },
    computed: {
      valueClass() {
        return this.display ? 'selected' : ''
      }
    },
    methods: {
      handleSelect() {
        if(this.disabled) {
          return
        }

        this.popup = true
      },
      handleConfirm() {
        this.popup = false
        let result = this.$refs[this.type].getValue()
        if(this.type === 'picker') {
          result = result[0]
          this.$emit('input', result[this.valueKey][0])
          this.display = result[this.labelKey]
        }
        this.$emit('confirm',result)
      },
      handleCancel() {
        this.popup = false
        this.$emit('cancel')
      },
      getInitialDisplay() {
        const { value, options, labelKey, valueKey } = this
        let initialValue = isArray(value) ? value : [value]
        let initialDisplay  = options.filter(opt => initialValue.includes(opt[valueKey])).map(item => item[labelKey])
        this.display = initialDisplay.join(',')
      }
    },
    mounted() {
      const { remote, options } = this
      if(!remote && options.length) {
        this.display = this.getInitialDisplay()
      }
    }
  };
</script>